// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793339395845
      var cssReload = require("/Users/votech/Documents/project/web/wave-writer-joecig/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  